import React from 'react';
import PropTypes from 'prop-types';

const Option = ({ title, onClick, disabled = false }) => (
  <div
    className={`${
      disabled ? 'bg-disabled' : 'bg-light'
    } rounded-3 p-4 border-transparent border cursor-pointer mb-2 d-flex flex-row align-items-center justify-content-between ${
      disabled ? '' : 'darken-primary-hover'
    }`}
    onClick={onClick}
    onKeyDown={onClick}
    style={{ pointerEvents: disabled ? 'none' : 'all' }}
    role="button"
    tabIndex="0">
    <p className="text-f5 text-bold">{title}</p>
    <i
      className="icon icon-arrow-next-navigation ms-auto text-primary"
      style={{ width: '1rem', height: '1rem' }}
    />
  </div>
);

export default Option;

Option.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

Option.defaultProps = {
  disabled: false,
};
